import { createContext, useCallback, useEffect, useMemo, useRef, type FC, type PropsWithChildren } from "react";

import type { IVSCodeIPC, VSCodeIPC } from "@/vscode-ipc";

type VSCodeIpcContextValue = {
    vscodeIpc: React.MutableRefObject<IVSCodeIPC | undefined>;
    setVscodeIpc: (ipc: VSCodeIPC | undefined) => void;
};

export const VSCodeIpcContext = createContext<VSCodeIpcContextValue | undefined>(undefined);

export const VSCodeIpcProvider: FC<PropsWithChildren> = ({ children }) => {
    const vscodeIpcRef = useRef<VSCodeIPC>();

    useEffect(() => {
        return () => {
            vscodeIpcRef.current?.dispose();
            vscodeIpcRef.current = undefined;
        };
    }, []);

    const setVscodeIpc = useCallback(
        (ipc: VSCodeIPC | undefined) => {
            vscodeIpcRef.current?.dispose();
            vscodeIpcRef.current = ipc;
        },
        [vscodeIpcRef],
    );
    const value = useMemo(
        () => ({
            vscodeIpc: vscodeIpcRef,
            setVscodeIpc,
        }),
        [setVscodeIpc],
    );

    return <VSCodeIpcContext.Provider value={value}>{children}</VSCodeIpcContext.Provider>;
};
